import { inject } from '@angular/core';
import { type ActivatedRouteSnapshot, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

import { AuthenticationService } from '@app/auth/services/authentication.service';
import { MODULE_ROUTE_PATH } from '@app/shared/constants/shared.constant';

/**
 * After user successfully logs in, this guard redirects it to home route
 */
export const redirectToHomeGuard = (route: ActivatedRouteSnapshot) => {
    const router = inject(Router);

    return inject(AuthenticationService)
        .fetchCurrentUserDetails()
        .pipe(
            map(() => {
                const returnUrl = route.queryParams.returnUrl || MODULE_ROUTE_PATH.HOME;
                router.navigate([returnUrl]);

                return false;
            }),
            catchError(() => of(true)),
            finalize(() => of(true)),
        );
};
